<template>
  <div class="playback-details">
    <a @click="expandToggle">
      <div v-if="expanded">
        <span v-html="titleText(playback)"></span>
        <span class="has-text-grey-light is-pulled-right">{{ playback.type }}
          <span class="icon">
            <i class="ion ion-ios-arrow-up"></i>
          </span>
        </span>
        <playback-embed v-if="playback.url" :playback="playback"></playback-embed>
        <h4 v-else>Nothing to display</h4>
        <div class="playback-details__content content">
          <div v-if="playback.caption" class="playback-details__caption" v-html="markdown(playback.caption)"></div>
          <hr v-if="playback.caption && playback.tombstone" />
          <div v-if="playback.tombstone" class="playback-details__tombstone is-size-7" v-html="markdown(playback.tombstone)"></div>
        </div>
      </div>
      <div v-else>
        <span v-html="titleText(playback)"></span>
        <span class="has-text-grey-light is-pulled-right">{{ playback.type }}
          <span class="icon">
            <i class="ion ion-ios-arrow-down"></i>
          </span>
        </span>
      </div>
    </a>
  </div>
</template>

<script>
import PlaybackEmbed from '@/components/PlaybackEmbed.vue'
import { markdown } from '@/utils.js'
export default {
  name: 'playbackDetails',
  components: { PlaybackEmbed },
  props: ['playback'],
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    expandToggle () {
      this.expanded = !this.expanded
    },

    // the markdown function will output the text to include <p>
    // tags, they aren't needed in the title, so are stripped here
    titleText (object) {
      if (object.name) {
        let str = this.markdown(object.name)
        return str.replace(/<\/*p>/g, '').trim()
      } else {
        return ''
      }
    },

    markdown: markdown
  }
}

</script>

<style lang="scss" scoped>
.playback-details__content {
  color: #000;
  padding: 1rem 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PlaybackDetails.vue?54b97e96